import React, { PropsWithChildren } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { toast } from 'react-toastify';
import TableauOnlineDashboard from '../../../components/TableauOnlineDashboard';
import { AuthenticationApi } from '../../../api/api.apiclient';
import { AppState } from '../../../store/store.types';

interface ReportsProps extends RouteComponentProps {
  code?: string;
  url?: string;
}

interface ReportsState {
  token?: string;
}

class Reports extends React.PureComponent<PropsWithChildren<ReportsProps>, ReportsState> {

  readonly state = {
    token: undefined
  };

  componentDidMount() {
    if (this.props.code) {
      this.getTableauToken();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  getTableauToken = async () => {
    if (this.props.code) {
      const token = await AuthenticationApi.tableau.getTableauToken(this.props.code);

      this.setState({ token });
    }
  };

  render() {
    return (
      <>
        {this.props.children}
        <main>
          {this.state.token && this.props.url && (
            <TableauOnlineDashboard
              token={this.state.token}
              source={this.props.url}/>
          )}
        </main>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  code: state.authentication.activeSupplier?.code
});

const ReportsEntity = connect(mapStateToProps, null)(Reports);

export default ReportsEntity;
